import { JSX, useCallback } from "react";

import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import ButtonGroup from "@mui/material/ButtonGroup";
import IconButton from "@mui/material/IconButton";

export type PictureActionbarProps = {
	videoInputs: number;

	onUploadImage: (event: Blob) => void;
	onOpenCamera: () => void;
};

function PictureActionbar(props: PictureActionbarProps): JSX.Element {
	const onClickInput = useCallback(
		(event: React.MouseEvent<HTMLInputElement>): void => {
			const element = event.target as HTMLInputElement;
			element.value = "";
		},
		[]
	);

	const selectImage = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>): void => {
			const files = event.target.files;
			if (!files || files.length === 0) {
				return;
			}

			for (const file of files) {
				props.onUploadImage(file);
			}
		},
		[props.onUploadImage]
	);

	return (
		<ButtonGroup>
			<IconButton component="label" aria-label="upload image">
				<InsertPhotoIcon />
				<input
					hidden
					type="file"
					accept=".jpg,.jpeg,.png"
					onClick={onClickInput}
					onChange={selectImage}
				/>
			</IconButton>
			<IconButton
				aria-label="open camera"
				disabled={props.videoInputs === 0}
				onClick={props.onOpenCamera}>
				<PhotoCameraIcon />
			</IconButton>
		</ButtonGroup>
	);
}

export default PictureActionbar;
